/**
 * This custom hook provides the functionality to save a course with the given parameters.
 */

import React from "react";

const usePagination = () => {

    // Pagination for the table handling
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(25);

    // Table pagination callback functions
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(event.target.value);
        setPage(0);
    };


    return {page, rowsPerPage, handleChangePage, handleChangeRowsPerPage}
}
export default usePagination;